import React, { useState, useEffect } from 'react';
import { Plus, Edit, Trash2, X, FileText } from 'lucide-react';
import { useAuth } from '../../App';
import { getDocuments, createDocument, updateDocument, deleteDocument } from '../../api/documents';
import AdminLayout from './AdminLayout';

const AdminDocuments = () => {
  const { token } = useAuth();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editDoc, setEditDoc] = useState(null);
  const [formData, setFormData] = useState({ title: '', slug: '', content: '', is_active: true, order: 0 });

  const fetchDocuments = async () => {
    try {
      const data = await getDocuments();
      setDocuments(data);
    } catch (err) {} finally { setLoading(false); }
  };

  useEffect(() => { fetchDocuments(); }, []);

  const openModal = (doc = null) => {
    if (doc) {
      setEditDoc(doc);
      setFormData({ title: doc.title, slug: doc.slug, content: doc.content, is_active: doc.is_active, order: doc.order });
    } else {
      setEditDoc(null);
      setFormData({ title: '', slug: '', content: '', is_active: true, order: 0 });
    }
    setModalOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editDoc) {
        await updateDocument(token, editDoc.id, formData);
      } else {
        await createDocument(token, formData);
      }
      setModalOpen(false);
      fetchDocuments();
    } catch (err) { alert('Błąd zapisu'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Usunąć dokument?')) return;
    try {
      await deleteDocument(token, id);
      fetchDocuments();
    } catch (err) {}
  };

  const generateSlug = (title) => {
    return title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  };

  return (
    <AdminLayout title="Dokumenty">
      <div className="flex justify-between items-center mb-6">
        <p className="text-[#9CA3AF]">Regulamin, Polityka prywatności i inne dokumenty</p>
        <button onClick={() => openModal()} className="btn-primary" data-testid="add-document-btn">
          <Plus size={18} /> Dodaj dokument
        </button>
      </div>

      {loading ? <div className="flex justify-center py-12"><div className="spinner"></div></div> : (
        <div className="space-y-4">
          {documents.map(doc => (
            <div key={doc.id} className="glass-card p-5 flex items-center justify-between" data-testid={`document-${doc.id}`}>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#10b981]/20 flex items-center justify-center text-[#10b981]">
                  <FileText size={20} />
                </div>
                <div>
                  <h3 className="text-white font-medium">{doc.title}</h3>
                  <p className="text-[#6B7280] text-sm">/dokument/{doc.slug}</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <span className={`px-2 py-1 rounded text-xs ${doc.is_active ? 'bg-[#10b981]/20 text-[#10b981]' : 'bg-[#6B7280]/20 text-[#6B7280]'}`}>
                  {doc.is_active ? 'Aktywny' : 'Ukryty'}
                </span>
                <div className="flex gap-2">
                  <button onClick={() => openModal(doc)} className="p-2 text-[#9CA3AF] hover:text-[#10b981]">
                    <Edit size={18} />
                  </button>
                  <button onClick={() => handleDelete(doc.id)} className="p-2 text-[#9CA3AF] hover:text-red-400">
                    <Trash2 size={18} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal */}
      {modalOpen && (
        <div className="modal-overlay" onClick={() => setModalOpen(false)}>
          <div className="modal-content max-w-2xl" onClick={e => e.stopPropagation()}>
            <div className="flex justify-between items-center p-6 border-b border-white/5">
              <h2 className="text-xl font-bold text-white">{editDoc ? 'Edytuj dokument' : 'Nowy dokument'}</h2>
              <button onClick={() => setModalOpen(false)} className="text-[#6B7280] hover:text-white"><X size={24} /></button>
            </div>
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              <div>
                <label className="block text-sm text-[#9CA3AF] mb-2">Tytuł *</label>
                <input type="text" value={formData.title} onChange={e => {
                  setFormData({...formData, title: e.target.value, slug: generateSlug(e.target.value)});
                }} className="w-full" required />
              </div>
              <div>
                <label className="block text-sm text-[#9CA3AF] mb-2">Slug (URL)</label>
                <input type="text" value={formData.slug} onChange={e => setFormData({...formData, slug: e.target.value})} className="w-full" />
              </div>
              <div>
                <label className="block text-sm text-[#9CA3AF] mb-2">Treść</label>
                <textarea value={formData.content} onChange={e => setFormData({...formData, content: e.target.value})} className="w-full" rows={12} />
              </div>
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="checkbox" checked={formData.is_active} onChange={e => setFormData({...formData, is_active: e.target.checked})} className="checkbox-custom" />
                <span className="text-white">Aktywny (widoczny na stronie)</span>
              </label>
              <div className="flex gap-3 pt-4">
                <button type="button" onClick={() => setModalOpen(false)} className="btn-ghost flex-1">Anuluj</button>
                <button type="submit" className="btn-primary flex-1">Zapisz</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </AdminLayout>
  );
};

export default AdminDocuments;